"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortRuleRoomsCount = exports.roomsCountSelectorOptions = exports.roomCountMapper = exports.ERoomCount = void 0;
/**
 * Данные для фильтра комнатности
 * Маппер для технических нужд, может быть полезен в целевом мкс
 * */
let ERoomCount = exports.ERoomCount = /*#__PURE__*/function (ERoomCount) {
  ERoomCount[ERoomCount["Studio"] = 9] = "Studio";
  ERoomCount[ERoomCount["OneRoom"] = 1] = "OneRoom";
  ERoomCount[ERoomCount["TwoRoom"] = 2] = "TwoRoom";
  ERoomCount[ERoomCount["ThreeRoom"] = 3] = "ThreeRoom";
  ERoomCount[ERoomCount["FourRoom"] = 4] = "FourRoom";
  return ERoomCount;
}({});
const roomsCountSelectorOptions = exports.roomsCountSelectorOptions = {
  [ERoomCount.Studio]: {
    label: 'Студия',
    selectedLabel: 'Студия',
    value: ERoomCount.Studio
  },
  [ERoomCount.OneRoom]: {
    label: '1',
    selectedLabel: '1 комн.',
    value: ERoomCount.OneRoom
  },
  [ERoomCount.TwoRoom]: {
    label: '2',
    selectedLabel: '2 комн.',
    value: ERoomCount.TwoRoom
  },
  [ERoomCount.ThreeRoom]: {
    label: '3',
    selectedLabel: '3 комн.',
    value: ERoomCount.ThreeRoom
  },
  [ERoomCount.FourRoom]: {
    label: '4+',
    selectedLabel: '4+ комн.',
    value: ERoomCount.FourRoom
  }
};
const sortRuleRoomsCount = exports.sortRuleRoomsCount = [ERoomCount.Studio, ERoomCount.OneRoom, ERoomCount.TwoRoom, ERoomCount.ThreeRoom, ERoomCount.FourRoom];
const roomCountMapper = exports.roomCountMapper = ['studio', 'oneRoom', 'twoRoom', 'threeRoom', 'fourRoom'];